import { useEffect } from "react";
import { useAuth } from "../providers/AuthProvider";
import use123zapStore from "../../stores/123zapStore";

export default function SessionBootstrap({ children }) {
  const { isAuthenticated } = useAuth();
  const loadPlanoAtual = use123zapStore((state) => state.loadPlanoAtual);

  useEffect(() => {
    if (isAuthenticated) {
      loadPlanoAtual(true);
    }
  }, [isAuthenticated, loadPlanoAtual]);

  return children;
}
